var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.colors.length
    ? _c("div", { staticClass: "select-color" }, [
        _vm.label
          ? _c("div", {
              staticClass: "select-color-label",
              domProps: { textContent: _vm._s(_vm.label) }
            })
          : _vm._e(),
        _vm.showColorName
          ? _c("span", { staticClass: "select-color-name" }, [
              _vm._v("\n    " + _vm._s(_vm.colorName) + "\n  ")
            ])
          : _vm._e(),
        _c(
          "ul",
          { staticClass: "select-color-colors" },
          [
            _vm._l(_vm.computedColors, function(c) {
              return _c(
                "li",
                {
                  key: c.id,
                  class: { active: c.modelId === _vm.activeColor },
                  attrs: { title: c.name },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.select(c)
                    }
                  }
                },
                [
                  c.type === "code"
                    ? _c("div", {
                        staticClass: "color-code",
                        style: { backgroundColor: c.value }
                      })
                    : _c("media", {
                        attrs: {
                          src: c.value,
                          width: "48",
                          height: "48",
                          alt: c.name
                        }
                      })
                ],
                1
              )
            }),
            _vm.colorsLimit && _vm.colors.length > _vm.colorsLimit
              ? _c("li", {
                  staticClass: "more-colors",
                  domProps: {
                    textContent: _vm._s(
                      "+" + (_vm.colors.length - _vm.colorsLimit)
                    )
                  },
                  on: { click: _vm.openProductCard }
                })
              : _vm._e()
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }